<style lang="scss">
  .zoezi-mypage .v-tabs-bar .v-tabs-bar__content {
    justify-content: center;
    .v-tab {
      min-width:50px;
      padding: 5px;
      text-transform: none;
      letter-spacing: 0;
      flex-wrap:wrap;
      font-size: 0.7em;
      .v-icon{
        display:block;
        width:90%;
      }
    }
  }

  .zoezi-mypage .tab-title {
      white-space: pre;
  }

  @media(min-width:600px){
    .zoezi-mypage .v-tabs-bar .v-tabs-bar__content {
      justify-content: left;
      .v-tab{
        font-size: .85em;
      }
    }

    .zoezi-mypage .tab-title {
      white-space: normal;
    }
  }
  @media(min-width:960px){
    .zoezi-mypage .v-tabs-bar .v-tabs-bar__content .v-tab{
      font-size: 1em;
      padding: 5px 10px;
    }

    .zoezi-mypage .tab-title {
      white-space: normal;
    }
  }
  .zoezi-mypage .square-box {
    height: 10em;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
  }
  .zoezi-mypage .shorten-text {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
</style>
<template>
    <div v-if="$store.state.user">
        <v-tabs
            :color="$root.siteconfig.appbar.props.activeColor"
            background-color="transparent"
            v-model="selectedTab"
            class="z-no-arrows"
        >
            <v-tab v-for="tab in tabs" :key="tab.id" :tabValue="tab.id">
                <v-icon small>{{tab.icon}}</v-icon>
                <span class="tab-title">{{tab.title}}</span><v-badge v-if="tab.badge" color="error" :content="tab.badge" class="ml-2" />
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="selectedTab">
            <v-tab-item v-if="tabs.find(x => x.id == 'start')" value="start" key="start">
                <div class="x mt-4">
                    <v-row>
                        <v-col cols="12">
                            <v-card v-for="card in messageCards" :key="card.id" :color="card.color" class="zoezi-card-default">
                                <v-card-title>{{$translate(card.title)}}</v-card-title>
                                <v-card-text v-html="card.text" />
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <h3 v-if="sections.length == 0">{{$translate('Here your bookings will be displayed')}}</h3>
                            <v-expansion-panels class="zoezi-my-activities" mandatory>
                                <!-- Dölj paneler som är tomma, öppna första panelen som har innehåll -->
                                <v-expansion-panel class="no-elevation" v-for="item in sections" :key="item.id">
                                    <v-expansion-panel-header>
                                        <div class="zoezi-activity-section">
                                            <h3>{{item.title}}</h3>
                                            <small>{{item.subtitle}}</small>
                                        </div>
                                        <v-badge color="grey" :content="item.bookings.length"></v-badge>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <div v-if="item.id == 'historic'" class="zoezi-card-default zoezi-card-horizontal z-clickable" @click="showHistoricalActivitiesDialog = true">
                                            <div class="z-card-image">
                                                <div class="z-card-image-time" :style="getBookingColorStyle({})">{{historicalActivitiesCount}} st</div>
                                                <div class="z-card-image-small" :style="getBookingColorStyle({})">fr. {{historyFrom.substring(0, 7)}}</div>
                                            </div>
                                            <div class="z-card-content">
                                                <strong>{{$translate('Show all past activities')}}</strong><br>
                                                <v-icon class="ml-n1" color="primary">mdi-calendar</v-icon> {{$translate('From')}} {{Date.formatFullShorter(historyFrom)}} {{Date.newFull(historyFrom).getFullYear()}}
                                            </div>
                                            <div class="z-card-action pt-2 px-2">
                                                <v-btn
                                                    class="zoezi-button-thin"
                                                    color="primary"
                                                    @click="showHistoricalActivitiesDialog"
                                                >
                                                    {{$translate('History')}}
                                                </v-btn>
                                            </div>
                                        </div>

                                        <template v-else v-for="(booking, index) in item.bookings">
                                            <v-subheader :key="`${booking.key}-hdr`" v-if="index === 0 || !Date.dateEquals(booking.start, item.bookings[index - 1].start)">
                                              {{ getDateSubTitle(booking.start) }}
                                            </v-subheader>
                                            <div class="zoezi-card-default zoezi-card-horizontal z-clickable" :key="booking.key" @click="showActivity(booking)" :style="{background:booking.background}">
                                                <!-- ResourceBooking Card -->
                                                <MyPageRBCard v-if="booking.type == 'resourcebooking'" :booking="booking" />

                                                <template v-else>
                                                    <div class="z-card-image" :style="{'background-image': 'url(' + $api.getImageUrl(booking.imagekey, 100) + ')' }">
                                                        <div class="z-card-image-time" :style="getBookingColorStyle(booking)">{{booking.start.hhmm()}}</div>
                                                        <div class="z-card-image-small" :style="getBookingColorStyle(booking)">{{booking.duration}} min</div>
                                                    </div>
                                                    <div class="z-card-content">
                                                        <strong>{{booking.text}}</strong><br>
                                                        <div v-if="!booking.start.isToday() && !booking.start.isTomorrow()"><v-icon color="primary">mdi-calendar</v-icon> {{Date.formatFullShort(booking.start)}}</div>
                                                        <div class="d-flex flex-row" v-if="booking.staffs && booking.staffs.length">
                                                            <div class="staff mr-2" v-for="staff in booking.staffs" :key="staff.id"><img v-if="staff.imagekey" :src="$api.getImageUrl(staff.imagekey, 100)" style="width:16px; border-radius:50%;"> {{staff.name}}</div>
                                                        </div>
                                                        <div class="location" v-if="booking.location || booking.room">
                                                            <v-icon class="ml-n1" color="primary">mdi-map-marker</v-icon>
                                                            <span v-if="booking.room">{{booking.room.name}}{{booking.location ? ', ': ' '}}</span>
                                                            <span v-if="booking.location">{{booking.location.name}}</span>
                                                        </div>
                                                    </div>
                                                    <div class="z-card-action pt-2 px-2">
                                                        <workout-book-button :workout="booking.workout" :info-on-unbookable="true" :showNumBooked="computedShowNumBooked" v-if="booking.workout" />
                                                        <v-btn
                                                            v-else-if="booking.type == 'resourcebooking'"
                                                            class="zoezi-button-thin"
                                                            color="primary"
                                                            @click="showActivity(booking)"
                                                        >
                                                            Info
                                                        </v-btn>
                                                    </div>

                                                    <div class="zoezi-booked-list" v-if="$store.state.user && booking.workout" style="flex-shrink: 0; width: 100%" :data-these-can-book-text="$translate('These can book')">
                                                        <workout-book-user-row
                                                            class="zoezi-booked-person"
                                                            :workout="booking.workout"
                                                            :user="user"
                                                            v-for="user in $store.state.user.canBookFor.filter(u => booking.workout.isBooked(u))"
                                                            :key="user.id"
                                                        />
                                                    </div>
                                                </template>
                                            </div>
                                        </template>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-col>
                        <!-- Kommande domaruppdrag -->
                        <v-col v-if="showRefereePage" cols="12">
                            <v-expansion-panels v-model="expandedRefereePanel" class="zoezi-my-activities">
                                <v-expansion-panel >
                                    <v-expansion-panel-header>
                                        <div>
                                            <h3>{{ $translate('Your coming referee assignments') }}</h3>
                                        </div>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <teamsport-coming-matches :referee="true" />
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-col>
                        <v-col>
                            <!-- Utforska -->
                        </v-col>
                    </v-row>
                    <div class='zoezi-training-overview' v-if="displayEntries || displayGroupTraining">
                        <h1>{{$translate('My workout summary')}}</h1>
                        <v-row class="mt-1 pa-1">
                            <template v-if="displayEntries && displayGroupTraining">
                                <v-col cols="12" md="6">
                                    <my-entry-stats :selectedDoors="filterByDoor" :minTimeToCount="timeBetweenCheckins" />
                                </v-col>
                                <v-col cols="12" md="6">
                                    <my-workout-stats />
                                </v-col>
                            </template>
                            <template v-else>
                                <v-col cols="12" md="12" v-if="displayEntries">
                                    <my-entry-stats :selectedDoors="filterByDoor" :minTimeToCount="timeBetweenCheckins" />
                                </v-col>
                                <v-col cols="12" md="12" v-if="displayGroupTraining">
                                    <my-workout-stats />
                                </v-col>
                            </template>
                        </v-row>
                    </div>
                </div>

            </v-tab-item>
            <v-tab-item v-if="tabs.find(x => x.id == 'payments')" eager value="payments" key="payments">
                <v-row v-if="hasMultipleLegalEntities && selectedSiteLegalEntityName">
                    <v-col cols=12>
                        <v-alert type="info" outlined class="mt-4 mx-2">
                            {{$translate('PAYMENTS_LEGAL_ENTITY_MB_INFO').format(selectedSiteLegalEntityName)}}
                        </v-alert>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col md=6 cols=12>
                        <coming-payments @count="numComingPayments = $event"/>
                        <receipt-list />
                    </v-col>
                    <v-col md=6 cols=12>
                        <v-expansion-panels v-model="expandedPaymentMethodsPanel">
                            <v-expansion-panel class="no-elevation" >
                                <v-expansion-panel-header>
                                    <div class="zoezi-activity-section">
                                        <h3>{{$translate('Payment method')}}</h3>
                                        <small>{{$translate('Here you can manage saved payment cards and direct debit mandates')}}</small>
                                    </div>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <my-payment-methods />
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-col>
                </v-row>
            </v-tab-item>
            <v-tab-item v-if="tabs.find(x => x.id == 'courses')" value="courses" key="courses">
                <!-- Should only be visible if there are courses -->
                <div class="x mt-4">
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-expansion-panels class="zoezi-my-activities" mandatory>
                                <!-- Dölj paneler som är tomma, öppna första panelen som har innehåll -->
                                <v-expansion-panel class="no-elevation" v-for="item in courses" :key="item.id">
                                    <v-expansion-panel-header>
                                        <div class="zoezi-activity-section">
                                            <h3>{{item.title}}</h3>
                                        </div>
                                        <v-badge color="grey" :content="item.bookings.length"></v-badge>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <div v-for="booking in item.bookings" :key="booking.id" @click="showCourseBooking(booking)">
                                            <course-booking-card :booking="booking" />
                                        </div>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-col>
                        <v-col md="6">
                            <v-expansion-panels class="zoezi-my-activities" mandatory>
                                <!-- Dölj paneler som är tomma, öppna första panelen som har innehåll -->
                                <v-expansion-panel class="no-elevation" v-for="item in watching" :key="item.id">
                                    <v-expansion-panel-header>
                                        <div class="zoezi-activity-section">
                                            <h3>{{item.title}}</h3>
                                            <small>{{item.subtitle}}</small>
                                        </div>
                                        <v-badge color="grey" :content="item.bookings.length"></v-badge>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <div v-for="booking in item.bookings" :key="booking.id" @click="showCourseBooking(booking)">
                                            <course-booking-card :booking="booking" />
                                        </div>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-col>
                    </v-row>
                </div>
            </v-tab-item>
            <v-tab-item v-if="tabs.find(x => x.id == 'cards')" value="cards" key="cards">
                <v-row>
                    <v-col cols=12>
                        <v-expansion-panels
                            v-model="expandedCardPanels"
                            accordion
                            flat
                            multiple
                            class="zoezi-my-activities"
                        >
                            <v-expansion-panel v-for="type in (hasMembership ? ['trainingcard', 'membership'] : ['trainingcard'])" :key="type" class="no-elevation">
                                <v-expansion-panel-header>
                                    <div class="zoezi-activity-section">
                                        <h3 v-if="type=='trainingcard'">{{$translate('Training card')}}</h3>
                                        <h3 v-if="type=='membership'">{{$translate('Membership')}}</h3>
                                    </div>
                                    <v-badge color="grey" :content="String(((type == 'trainingcard' ? validAndFrozenTrainingCards : validMemberships) || []).length)"></v-badge>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <div v-if="type=='trainingcard' && validAndFrozenTrainingCards && validAndFrozenTrainingCards.length == 0" class="text--secondary">
                                        {{$translate("You don't have a training card")}}
                                    </div>
                                    <div v-else-if="type=='membership' && validMemberships && validMemberships.length == 0" class="text--secondary">
                                        {{$translate('You have no membership')}}
                                    </div>
                                    <div v-else v-for="card in (type == 'trainingcard' ? validAndFrozenTrainingCards : validMemberships)" :key="card.id">
                                        <div v-if="card.chain && Date.newFull(card.validToDate).isFutureDate()" class="pa-3">
                                            <strong>{{ $translate('Membership in another association') }}</strong><br>
                                            <span><v-icon small>mdi-calendar-clock</v-icon> {{$translate('Valid until')}} {{Date.formatFullShort(card.validToDate) + ' ' + Date.newFull(card.validToDate).getFullYear()}}</span>
                                        </div>
                                        <template v-else>
                                            <TrainingCardAndMembershipCard :card="card" class="pb-2" />
                                        </template>
                                    </div>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-col>
                </v-row>

            </v-tab-item>
            <v-tab-item v-if="tabs.find(x => x.id == 'teamsport')" value="teamsport" key="teamsport">
                <v-tabs v-model="selectedTeamsportTab" centered background-color="transparent">
                    <v-tab v-for="tab in teamsportTabs" :key="tab.id" :value="tab.id" :tabValue="tab.id">{{ tab.title }}</v-tab>
                </v-tabs>

                <v-tabs-items v-model="selectedTeamsportTab" class="mt-2">
                    <v-tab-item v-if="teamsportTabs.find(x => x.id === 'registrations')" key="registrations" value="registrations">
                        <component-wrapper
                            :config="{component: 'zoezi-my-teamsport-registrations', style: {pageParams: [{prop: 'activeTeam', id: 'team'}]}}"
                        />
                        <!-- Dummy reference to avoid the linter warning -->
                        <template v-if="false">
                            <MyTeamsportRegistrations />
                        </template>
                    </v-tab-item>
                    <v-tab-item v-if="teamsportTabs.find(x => x.id === 'referee')" key="referee" value="referee" class="ma-2">
                        <teamsport-matches referee/>
                    </v-tab-item>
                    <v-tab-item v-if="teamsportTabs.find(x => x.id === 'playerpool')" key="playerpool" value="playerpool" class="ma-2">
                        <TeamsportPlayerPool/>
                    </v-tab-item>
                </v-tabs-items>
            </v-tab-item>
            <v-tab-item v-if="tabs.find(x => x.id == 'family')" value="family" key="family">
                <family/>
            </v-tab-item>
            <v-tab-item v-if="tabs.find(x => x.id == 'account')" value="account" key="account">
                <v-row>
                    <v-col cols="12" md="6" lg="7"><my-account/></v-col>
                </v-row>
            </v-tab-item>
        </v-tabs-items>

        <workout-dialog v-model="showWorkoutDialog" :workout="showingWorkout" :showNumBooked="computedShowNumBooked" :showLastnameForInstructors="showLastnameForInstructors" v-if="showWorkoutDialog"/>
        <resource-booking-dialog v-model="showResourceBookingDialog" :booking="showingResourceBooking" v-if="showResourceBookingDialog" />
        <course-booking-dialog v-model="showCourseBookingDialog" :booking="showingCourseBooking" v-if="showCourseBookingDialog" />

        <v-dialog
            v-model="showHistoricalActivitiesDialog"
            max-width="800"
            scrollable
        >
            <v-card>
                <v-card-title class="headline pa-2 primary primarytext--text d-flex fill-width">
                    {{$translate('Earlier activities')}}
                    <v-spacer />
                    <v-btn icon @click="showHistoricalActivitiesDialog = false" ><v-icon class="primary primarytext--text">mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-card-text>
                    <historical-bookings :from-date="historyFrom" :to-date="Date.today().addDays(-1)" />
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import MyAccount from "./MyAccount.vue";
import CourseBookingDialog from '../components/CourseBookingDialog.vue'
import WorkoutDialog from '../components/WorkoutDialog.vue'
import ResourceBookingDialog from '../components/ResourceBookingDialog.vue'
import ReceiptList from '../views/ReceiptList.vue'
import ComingPayments from '../views/ComingPayments.vue'
import WorkoutBookButton from '../components/WorkoutBookButton.vue'
import WorkoutBookUserRow from '../components/WorkoutBookUserRow.vue'
import MyPaymentMethods from '../views/MyPaymentMethods.vue'
import Family from './Family.vue'
import MyTeamsportRegistrations from './MyTeamsportRegistrations.vue'
import TeamsportMatches from "./TeamsportMatches.vue";
import HistoricalBookings from '../views/HistoricalBookings.vue'
import MyEntryStats from '../views/MyEntryStats.vue'
import MyWorkoutStats from '../views/MyWorkoutStats.vue'
import MyPageRBCard from '../components/MyPageRBCard.vue'
import TeamsportPlayerPool from './TeamsportPlayerPool.vue'
import TeamsportComingMatches from './TeamsportComingMatches.vue'
import CourseBookingCard from '../views/CourseBookingCard.vue'
import TrainingCardAndMembershipCard from "../components/TrainingCardAndMembershipCard.vue";

export default {
    name: "zoezi-mypage",

    zoezi: {
        title: "My page",
        icon: "mdi-account-box-outline",
        getDefaultStyle: () => ({
            pageParams: [
                {
                    id: 'tab',
                    prop: 'activeTab'
                },
                {
                    id: 'ttab',
                    prop: 'activeTeamsportTab'
                }
            ]
        })
    },

    components: {
        MyAccount,
        CourseBookingDialog,
        WorkoutDialog,
        ResourceBookingDialog,
        ReceiptList,
        ComingPayments,
        WorkoutBookButton,
        WorkoutBookUserRow,
        MyPaymentMethods,
        Family,
        MyTeamsportRegistrations,
        TeamsportPlayerPool,
        TeamsportMatches,
        HistoricalBookings,
        MyEntryStats,
        MyWorkoutStats,
        MyPageRBCard,
        TeamsportComingMatches,
        CourseBookingCard,
        TrainingCardAndMembershipCard
    },

    props: {
        showHistoricActivities: {
            title: 'Show previous activities',
            type: Boolean,
            default: true
        },
        historyMonths: {
            title: 'Number of months old activities (Applies only to "Show past activities")',
            type: Number,
            default: 12
        },
        displayEntries: {
            title: 'Show Entries',
            type: Boolean,
            default: true
        },
        displayGroupTraining: {
            title: 'Show Group Training',
            type: Boolean,
            default: true
        },
        displayPaymentsTab: {
            title: 'Show Payments tab',
            type: Boolean,
            default: true
        },
        displayTrainingCardTab: {
            title: 'Show Training card tab',
            type: Boolean,
            default: true
        },
        displayFamilyTab: {
            title: 'Show Family tab',
            type: Boolean,
            default: true
        },
        filterByDoor: {
            title: 'Filter by door',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                getItems() {
                    return window.$zoeziapi.get('/api/resource/get').then(resources => {
                        const doors = resources.filter(resource => resource.resourceType == 'door')
                        return doors.map(({lastname, id}) => ({name: lastname, id}));
                    })
                },
                text: 'name',
                value: 'id',
                multiple: true,
                placeholder: 'Show all doors',
            },
            default: () => []
        },
        timeBetweenCheckins: {
            title: 'Number of hours between counting entries per day (e.g., 6 hours)',
            type: Number,
            default: 6
        },
        activeTab: {
            title: 'Active tab',
            type: String,
            default: 'start'
        },
        activeTeamsportTab: {
            title: 'Active teamsport tab',
            type: String,
            default: 'registrations'
        },
        showLastnameForInstructors: {
            title: 'Show last name for instructors',
            type: Boolean,
            default: false
        }
    },
    watch: {
        '$store.state.user': {
            immediate: true,
            handler(user) {
                if (user) {
                    if (this.$route.query.accountrequest) {
                        this.selectedTab = 'family';
                    } else if (this.$route.query.showinvoice) {
                        this.selectedTab = 'payments';
                    } else if (this.activeTab) {
                        this.selectedTab = this.activeTab;
                    }
                    if (this.activeTeamsportTab) {
                        this.selectedTeamsportTab = this.activeTeamsportTab;
                    }

                    this.getHistoricalActivitiesCount();
                }
            }
        },
        showHistoricActivities: {
            immediate: true,
            handler() {
                this.getHistoricalActivitiesCount();
            }
        },
        historyMonths: {
            immediate: true,
            handler() {
                this.getHistoricalActivitiesCount();
            }
        },
        selectedTab() {
            this.setProp('activeTab', this.selectedTab);
        },
        selectedTeamsportTab() {
            this.setProp('activeTeamsportTab', this.selectedTeamsportTab);
        }
    },
    computed: {
        numberOfBlockedManagedAccounts(){ // FIXME: Why do we have this?
            return this.$store.state.user.canManage.filter(x => x.warnedUntil !=null ).length || 0;
        },
        bookings() {
            return this.$store.getters.comingBookings;
        },
        courseBookings() {
            return this.bookings?.coursebookings?.concat().sort((a,b) => Date.newFull(a.startTime).getTime() - Date.newFull(b.startTime).getTime());
        },
        ongoingCourses() {
            return this.courseBookings?.filter(b => this.$store.state.now30s.withinRange(Date.newFull(b.startTime), Date.newFull(b.endTime)));
        },
        comingCourses() {
            return this.courseBookings?.filter(b => Date.newFull(b.startTime).isFutureDate(true)).sort((a,b) => Date.newFull(a.startTime).getTime() - Date.newFull(b.startTime).getTime());
        },
        courseWatches() {
            return this.bookings?.coursewatches?.concat().sort((a,b) => Date.newFull(a.startTime).getTime() - Date.newFull(b.startTime).getTime());
        },
        workoutBookingsAndResourceBookings() {
            let res = [];
            if (this.bookings) {
                this.bookings.workouts.forEach(wb => {
                    if (res.find(x => x.key ==  'wb' + wb.id)) {
                        return;
                    }

                    res.push({
                        key: 'wb' + wb.id,
                        type: 'workout',
                        id: wb.id,
                        start: Date.newFull(wb.startTime),
                        color: wb.workoutType.color,
                        text: wb.workoutType.name + (wb.extra_title ? ' - ' + wb.extra_title : ''),
                        imagekey: wb.workoutType.imagekey,
                        duration: (Date.newFull(wb.endTime).getTime() - Date.newFull(wb.startTime).getTime()) / (60 * 1000),
                        staffs: wb.staffs.map(s => {s.name = this.showLastnameForInstructors ? `${s.firstname} ${s.lastname}` : `${s.firstname} ${s.lastname.substring(0, 1)}`; return s;}),
                        location: wb.location,
                        room: wb.room,
                        workout: wb,
                        background: wb.status == 'Cancelled' ? '#fbeeed' : (wb.isInQueue() ? '#fed' : null)
                    });
                })

                // Group resource bookings by parent_id and date (siblings)
                const rbMap = new Map();
                this.bookings.resourcebookings.forEach(rb => {
                    const date = Date.newFull(rb.time).yyyymmdd();
                    const key = rb.parent_id ? `${rb.parent_id}_${date}` : `single_${rb.id}`;
                    
                    if (!rbMap.has(key)) {
                        rbMap.set(key, {
                            key: 'rb' + (rb.parent_id || rb.id),
                            type: 'resourcebooking',
                            id: rb.id,
                            rb,
                            siblings: [],
                            start: Date.newFull(rb.time),
                            text: rb.servicename,
                            imagekey: rb.service_imagekey,
                            duration: rb.duration,
                            staffs: []
                        });
                    }
                    
                    const grouped = rbMap.get(key);
                    grouped.siblings.push(rb);
                    
                    // Add staff to the list if not already present
                    if (rb.staff_id && !grouped.staffs.find(s => s.id === rb.staff_id)) {
                        grouped.staffs.push({id: rb.staff_id, name: rb.staffname, imagekey: rb.staff_imagekey});
                    }
                });
                
                // Add grouped bookings to result
                rbMap.forEach(grouped => {
                    // Update rb to be the first sibling for consistency
                    grouped.rb = grouped.siblings[0];
                    res.push(grouped);
                });
            }
            return res;
        },
        activities() {
            return this.workoutBookingsAndResourceBookings.concat().sort((a,b) => a.start.getTime() - b.start.getTime());
        },
        courses() {
            return [
                {id: 'ongoing', title: this.$translate('Active courses'), bookings: this.ongoingCourses },
                {id: 'coming', title: this.$translate('Upcoming courses'), bookings: this.comingCourses }
            ].filter(c => c.bookings?.length);
        },
        hasMembership() {
            return this.$store.state?.settings?.membership;
        },
        hasTeamsports() {
            return this.$store.state?.settings?.teamsports != false;
        },
        hasPlayerPool() {
            return this.$store.state.settings?.playerpool != false;
        },
        hasCoursesModule() {
            return this.$store.state?.settings?.modules.Courses;
        },
        hasMultipleLegalEntities() {
            return this.$store.state?.settings?.modules.MultipleLegalEntities;
        },
        visibleGroups() {
            return this.$store.state?.user?.groups?.filter(g => g.show) ?? [];
        },
        cardsAndMemberships() {
            let canManage = (card) => card.user_id == this.$store.state.user.id || !!this.$store.state.user.canManage.find(x => x.id == card.user_id);
            let now = this.$store.state.now30s.clone().clearTime();
            let isHistoric = (card) => !this.$booking.isCardValid(card, now, 1, false) && card.validToDate && (card.validToDate.isPastDate() || (card.trainingsLeft == 0 && !card.boundToDate));
            return this.$store.state.cards?.filter(card => (!!canManage(card) || this.findUserGroupsForCard(card)) && !isHistoric(card));
        },
        validAndFrozenTrainingCards() {
            return this.cardsAndMemberships?.filter(c => !c.membership);
        },
        validMemberships() {
            return this.cardsAndMemberships?.filter(c => c.membership);
        },
        tabs() {
            if (!this.$store.state.user) {
                return [];
            }

            let cardsTitle = this.hasMembership && !this.$vuetify.breakpoint.mobile ? `${this.$translate('Training card')} &\n ${this.$translate('Membership')}` : this.$translate('Training card');
            if (cardsTitle == `${this.$translate('Training card')} & ${this.$translate('Membership')}`) {
                cardsTitle = `${this.$translate('Training card')} &\n ${this.$translate('Membership')}`;
            }
            const showTeamsports = this.hasTeamsports;
            const showCourses = this.hasCoursesModule;

            return [
                { id: 'start', title: this.$translate('Overview'), icon: 'mdi-calendar-today'},
                this.displayPaymentsTab && { id: 'payments', title: this.$translate('Payments'), icon: 'mdi-wallet', badge: this.numComingPayments},
                showCourses && { id: 'courses', title: this.$translate('Courses'), icon: 'mdi-school'},
                this.displayTrainingCardTab && { id: 'cards', title: cardsTitle, icon: 'mdi-ticket'},
                showTeamsports && { id: 'teamsport', title: this.$translate('Competition'), icon: 'mdi-account-multiple' },
                this.displayFamilyTab && { id: 'family', title: this.$translate('Family'), icon: 'mdi-human-male-female-child', badge: this.$store.state.user.requests.length + this.numberOfBlockedManagedAccounts},
                { id: 'account', title: this.$translate('Account'), icon: ' mdi-account-circle'}
            ].filter(x => !!x)
        },
        teamsportTabs() {
            return [
                { id: 'registrations', title: this.$translate('Registrations')},
                this.showRefereePage && { id: 'referee', title: this.$translate('Referee assignments')},
                this.hasPlayerPool && { id: 'playerpool', title: this.$translate('Player pool')}
            ].filter(x => !!x);
        },
        showRefereePage() {
            return this.$store.state.user?.showRefereeSchedule;
        },
        watching() {
            return [{id: 'watching', title: this.$translate('Watches'), subtitle: this.$translate('where you\'re waiting for a place'), bookings: this.courseWatches },
            ].filter(c => c.bookings?.length);
        },
        sections() {
            let today = this.$store.state.now30s.clone().clearTime();
            let tomorrow = today.clone().addDays(1);

            let activitiesToday = this.activities.filter(a => Date.dateEquals(a.start, today));
            let activitiesTomorrow = this.activities.filter(a => Date.dateEquals(a.start, tomorrow));
            let activitiesLater = this.activities.filter(a => a.start.clone().clearTime().getTime() > tomorrow);
            let activitiesEarlier = [];
            if (this.historicalActivitiesCount) {
                activitiesEarlier = Array.apply(null, Array(this.historicalActivitiesCount)).map(() => ({id: 0}));
            }

            const historicSubtitle = activitiesEarlier.length == 1 ? this.$translate('1 previous activity') : this.$translate('{0} previous activities').format(activitiesEarlier.length);

            return [
                {id: 'today', title: this.$translate('Today'), subtitle: this.getDateSubTitle(today), bookings: activitiesToday},
                {id: 'tomorrow', title: this.$translate('Tomorrow'), subtitle: this.getDateSubTitle(tomorrow), bookings: activitiesTomorrow },
                {id: 'later', title: this.$translate('Later'), subtitle: this.$translate('bookings after tomorrow'), bookings: activitiesLater},
                {id: 'historic', title: this.$translate('Previous activities'), subtitle: historicSubtitle, bookings: activitiesEarlier, singleCard: true }
            ].filter(c => c.bookings?.length);
        },
        historyFrom() {
            return Date.today().addMonths(-this.historyMonths).yyyymmdd();
        },
        messageCards() {
            const blocktypes = [
                {id: 'block_entry', name: 'Entry'},
                {id: 'block_autogiro', name: 'Sign direct debit'},
                {id: 'block_grouptraining', name: 'Group workout'},
                {id: 'block_course', name: 'Course booking'},
                {id: 'block_resourcebooking', name: 'Resource booking'}
            ];

            let blocks = this.$store.state.user.blocks;
            return blocks.map(block => {
                let blocklist = blocktypes.filter(t => block[t.id]).map(t => this.$translate(t.name).toLowerCase()).join(', ')
                let until = block.toDate ? (this.$translate('until') + ' <b>' + Date.formatFullShorter(block.toDate) + '.</b>') : ' ' + this.$translate('until furhter notice');
                let message = block.message ? (`<br><br>${block.message}<br><br>`) : '<br>';

                return {
                    id: 'block.' + block.id,
                    color: '#fcb2b2',
                    title: 'Blocked',
                    text: this.$translate('You have been blocked from {0}{1}The block is valid {2}').format(blocklist, message, until)
                };
            });
        },
        computedShowNumBooked() {
            return this.$store.state.settings?.wbshowbookingcount;
        },
        showRefereeAssignments() {
            return this.$store.state?.user?.showRefereeSchedule;
        },
        selectedSiteLegalEntity() {
            const selectedSite = this.$store.state.settings?.sites?.find(
                site => site.id === this.$store.state.selectedSiteId
            );
            return selectedSite?.legal_entity;
        },
        selectedSiteLegalEntityName() {
            return this.selectedSiteLegalEntity?.name;
        }
    },
    data: () => ({
        selectedTeamsportTab: 'registrations',
        selectedTab: "start",
        showWorkoutDialog: false,
        showingWorkout: null,
        showResourceBookingDialog: false,
        showingResourceBooking: null,
        showCourseBookingDialog: false,
        showingCourseBooking: null,
        numComingPayments: null,
        showTrainingCardDialog: false,
        expandedCardPanels: [0,1],
        expandedPaymentMethodsPanel: 0,
        historicalActivitiesCount: null,
        showHistoricalActivitiesDialog: false,
        groupInvite: null,
        showGroupInviteDialog: false,
        expandedRefereePanel: 0
    }),

    methods: {
        findUserGroupsForCard(card) {
            return this.$store.state?.user?.groups?.filter(x => x.show && x.trainingcards?.includes(card.id));
        },
        showCourseBooking(booking) {
            this.showingCourseBooking = booking
            this.showCourseBookingDialog = true;
        },
        getDateSubTitle(date) {
            date = Date.newFull(date);

            let weekday = window.$translate(date.getWeekDayString())
            let lc = (x) => window.$store.state.language == 'sv' ? x.toLowerCase() : x;

            return `${lc(weekday)} ${date.getDate()} ${lc(window.$translate(date.getMonthName()))}`;
        },
        showActivity(booking) {
            if (booking.type == 'workout') {
                this.$api.get('/api/memberapi/workout/get', {id: booking.id}).then(x => {
                    this.$booking.transformWorkout(x);
                    this.showWorkoutDialog = true;
                    this.showingWorkout = x;
                }).catch(() => {
                    this.$store.commit('showErrorDialog', {title: this.$translate('Error displaying booking'), text: this.$translate('The booking could not be displayed')})
                })
            } else if (booking.type == 'resourcebooking') {
                this.showResourceBookingDialog = true;
                this.showingResourceBooking = booking;
            }
        },
        getBookingColorStyle(booking) {
            return {
                'background-color': booking.color ? (booking.color+'b4') : 'rgba(192,160,0,0.7)'
            }
        },
        getHistoricalActivitiesCount() {
            this.historicalActivitiesCount = null;
            if (this.showHistoricActivities && this.$store.state.user) {
                let startDate = this.historyFrom;
                let endDate = Date.today().addDays(-1).yyyymmdd();
                this.$api.get('/api/memberapi/bookings/get', {startTime: startDate, endTime: endDate, returnCount: true}).then(x => {
                    this.historicalActivitiesCount = x;
                })
            }
        }
    }
};
</script>
